import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_5001a0cc";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_5001a0cc" };
/** script content **/
require("./date-picker-modal.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex5001a0cc%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fdate-picker-modal%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_5001a0cc"],
    ctorType: "component",
    outputPath: "components/index5001a0cc/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-picker-modal-base': getComponent(require("../picker-modal/picker-modal-base.mpx?isComponent&outputPath=components%2Fpicker-modal-base6c849b9a%2Findex")), 'cube-date-picker': getComponent(require("../date-picker/index.mpx?isComponent&outputPath=components%2Findexc2f4660c%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
